import type {CustomerLogo} from '@/ui/logos-carousel';

export const LOGO_BASE = '/static/images/industry-real-estate-and-property-management/customer-logos';

/** `file` matches the basename in customer-logos/ (without .png), including the `_2x` suffix. */
export const CUSTOMER_LOGOS: CustomerLogo[] = [
  {file: 'peakmade_2x', label: 'PeakMade', width: 160, height: 80},
  {file: 'baird&warner_2x', label: 'Baird & Warner', width: 160, height: 80},
  {file: 'mI homes_2x', label: 'M/I Homes', width: 160, height: 80},
  {file: 'lgi_2x', label: 'LGI Homes', width: 160, height: 80},
  {file: 'floridarealtors_2x', label: 'Florida Realtors', width: 160, height: 80},
  {file: 'houseful_2x', label: 'Houseful', width: 160, height: 80},
  {file: 'workman_2x', label: 'Workman', width: 160, height: 80},
  {file: 'wsdevelopment_2x', label: 'WS Development', width: 160, height: 80},
  {file: 'glenveaugh_2x', label: 'Glenveagh', width: 160, height: 80},
  {file: 'tonti_2x', label: 'Tonti Properties', width: 160, height: 80},
  {file: 'perry_2x', label: 'Perry Homes', width: 160, height: 80},
  {file: 'citywide_2x', label: 'Citywide', width: 160, height: 80},
  {file: 'together_2x', label: 'Together', width: 160, height: 80},
  {file: 'sola_2x', label: 'Sola', width: 160, height: 80},
  {file: 'ipg_2x', label: 'IPG', width: 160, height: 80},
  {file: 'esr_2x', label: 'ESR', width: 160, height: 80},
  {file: 'logisticparks_2x', label: 'Logistic Parks', width: 160, height: 80},
  {file: 'assosia_2x', label: 'Assosia', width: 160, height: 80},
  {file: 'osool_2x', label: 'Osool', width: 160, height: 80},
  {file: 'nawy_2x', label: 'Nawy', width: 160, height: 80}
];
